import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { PostPreview } from './PostPreview.jsx';
import { useGetPostTiles } from '../Posts/hooks/useGetPostTiles';
import { Container, Section } from './StyledComponents';
import Text from '../../../../shared/Text';

export const ReviewWithoutNotificationsStep = ({ post }) => {
  const { t } = useTranslation('postNotifications');
  const tiles = useGetPostTiles({ uuid: post.uuid });

  return (
    <ReviewContainer>
      <ReviewSection>
        <Text padding="14px 24px" as="div" variant="h6">
          {t('reviewStep.title')}
        </Text>
        <PostsContainer>
          <PostPreview tiles={tiles} />
        </PostsContainer>
      </ReviewSection>
    </ReviewContainer>
  );
};

const ReviewSection = styled(Section)`
  width: 676px;
`;

const PostsContainer = styled.div`
  border-top: 1px solid ${themeGet('colors.black.10')};
`;

const ReviewContainer = styled(Container)`
  margin: 0 auto;
  gap: 0;

  &:after {
    content: '';
    display: block;
    min-height: 24px;
  }
`;
